import { render, staticRenderFns } from "./OutstandingLoan.vue?vue&type=template&id=5018bfad"
import script from "./OutstandingLoan.vue?vue&type=script&lang=js"
export * from "./OutstandingLoan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports